export const MainMenu = [
    {label: "menu.company", path: "/company"},
    {label: "menu.features", path: "/features"},
    {label: "menu.app", path: "/app"}
]
